export const LOYALTY_CATEGORY = 'loyalty-program';
